import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import {
    updateObservation,
    clear_observations,
    UPDATE_OBSERVATION,
    getAllObservations,
    createWorkSubprocessObservation,
    CREATE_WORK_SUBPROCESS_OBSERVATION,
    deleteWorkSubprocessObservation,
    DELETE_WORK_SUBPROCESS_OBSERVATION
} from "../../../redux/observations";
import Footer from "../../../components/footer";
import {Switch, Space} from "antd";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
import Select from "react-select";
import {searchSubProcess} from "../../../redux/work_subprocess";

const UpdateObservation = () => {
    let history = useHistory();
    const {id} = useParams();

    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_observations = useSelector((state) => state.observations_module._get_all_observations);

    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [optionsSubprocess, setOptionsSubprocess] = useState([]);
    const [subprocess_select, setSubprocessSelect] = useState([]);

    const get_subprocess = async () => {
        const params = '';
        const response = await searchSubProcess(token, params);
        try {
            if (response && response.data && response.data.datos) {
                // eslint-disable-next-line
                let options = response.data.datos.map((item) => {
                    if (item.activo === true) {
                        return {
                            value: item.id,
                            label: item.nombre,
                        };    
                    }
                });
                setOptionsSubprocess(options);
            }
        } catch (e) {
            console.log('Error')
        }
    }

    const handleChangeSelect = (e) => {
        setSubprocessSelect(e);
    };

    const _update_observation = useSelector((state) => state.observations_module._update_observation);
    const _create_work_subprocess_observation = useSelector((state) => state.observations_module._create_work_subprocess_observation);
    const _delete_work_subprocess_observation = useSelector((state) => state.observations_module._delete_work_subprocess_observation);

    const [form, setForm] = useState({
        descripcion: "",
        activo: true,
        subprocesos: [],
    });

    // eslint-disable-next-line
    const [data, setData] = useState({
        subprocesos: [],
    });

    useEffect(() => {
        if (_get_all_observations.data.datos) {
            let item = _get_all_observations.data.datos.filter((x) => x.id === parseInt(id))
            if (item.length > 0) {
                // eslint-disable-next-line
                let subprocess = item[0].subprocesos.map((x) => {
                    return {
                        value: x.id,
                        label: x.nombre,
                    };
                })
                setForm({
                    descripcion: item[0].descripcion,
                    activo: item[0].activo,
                    subprocesos: subprocess
                })
                setSubprocessSelect(subprocess);
            }
        }
    }, [_get_all_observations, id]);

    useEffect(() => {
        if (_update_observation.status === 200) {
            dispatch(clear_observations(UPDATE_OBSERVATION));
            history.push("/observaciones");
            dispatch(getAllObservations(token));
            setIsLoading(false);
        } else if (_update_observation.status !== 0) {
            dispatch(clear_observations(UPDATE_OBSERVATION));
            toast.error(_update_observation.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_observation, dispatch, history, token]);

    useEffect(() => {
        if (_delete_work_subprocess_observation.status === 200) {
            dispatch(clear_observations(DELETE_WORK_SUBPROCESS_OBSERVATION));
            dispatch(getAllObservations(token));
            setIsLoading(false);
        } else if (_delete_work_subprocess_observation.status !== 0) {
            dispatch(clear_observations(DELETE_WORK_SUBPROCESS_OBSERVATION));
            toast.error(_delete_work_subprocess_observation.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_delete_work_subprocess_observation, dispatch, history, token]);

    useEffect(() => {
        if (_create_work_subprocess_observation.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_observations(CREATE_WORK_SUBPROCESS_OBSERVATION));
            dispatch(getAllObservations(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_work_subprocess_observation.status !== 0) {
            dispatch(clear_observations(CREATE_WORK_SUBPROCESS_OBSERVATION));
            toast.error(_create_work_subprocess_observation.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_work_subprocess_observation, dispatch, history, token]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar la descripción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateObservation(token, id, form));
    };

    const handleSubmitSubprocess = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let array = subprocess_select.map((item) => {
            return {
                id_subproceso: item.value,
            };
        });
        data.subprocesos = array;
        if (data.subprocesos.length === 0) {
            toast.error("Debe seleccionar al menos un subproceso", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        dispatch(createWorkSubprocessObservation(token, id, data));
    };

    function delete_item(id_subproceso) {
        setIsLoading(true);
        dispatch(deleteWorkSubprocessObservation(token, id, id_subproceso));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Observaciones"
                            items={[
                                {label: "Detalles", link: "/obsevaciones"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar Observación</h4>
                                </div>
                                <div className="card-body">
                                    <div><ToastContainer/></div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Input
                                                name="descripcion"
                                                label="descripcion"
                                                value={form.descripcion}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mt-md-2">
                                                <Space size={14} direction='horizontal'>
                                                    <strong>Activo</strong>
                                                    <Switch
                                                        checked={form.activo}
                                                        checkedChildren="SI"
                                                        unCheckedChildren="NO"
                                                        onChange={handleCheckedChange}
                                                    />
                                                </Space>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mb-2">
                                            <p className="text-title">Subprocesos</p>
                                            <p className="text-body">Sección para asignar a los subprocesos que
                                                conforman la observación</p>
                                            <Button type="button" text="Agregar" theme="calendar" classes="mb-1"
                                                    onChange={() => {
                                                        get_subprocess();
                                                        setModal(true);
                                                    }}/>
                                        </div>
                                        {form.subprocesos.length > 0 && (
                                            form.subprocesos.map((item) => (
                                                <div className="col-md-4 col-sm-6 col-12 mb-1">
                                                    <div className="d-flex p-1 border-card">
                                                        <div className="d-flex" style={{width: '90%'}}>
                                                            <div className="ml-1">
                                                                <span>{item.label}</span><br/>
                                                            </div>
                                                        </div>
                                                        <div className="text-right" style={{width: '10%'}}>
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/delete.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    delete_item(item.value)
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                    <div className="card-footer button_responsive">
                                        <Link to="/observaciones"
                                              className="btn btn-outline-dark magin_button button_responsible">
                                            Cancelar
                                        </Link>
                                        <Button type="submit" text="Guardar" classes="button_responsible" theme="calendar"
                                                disabled={isLoading}/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmitSubprocess}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agregar subproceso</h5>
                        <div className="form-group">
                            <label>Subproceso</label>
                            <Select
                                value={subprocess_select}
                                options={optionsSubprocess}
                                isMulti={true}
                                onChange={handleChangeSelect}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default UpdateObservation;
